import React, {useState, useEffect} from "react";
import _ from "lodash";

import styles from "./Account.module.scss";
import Host from "../../types/Host";
import World from "../../world";

import { LogoContainer } from "../LogoContainer";
import { ActionLink } from "../ActionLink";
import GalleryList from "../GalleryList";
import Gallery from "../../types/Gallery";

export interface AccountProps {
    host: Host;
    world: World;
    onLogout: () => void;
    is_trial?: boolean;
}

export const Account = (props: AccountProps) => {
    const [galleries, setGalleries] = useState<Gallery[]>(_.values(props.world.galleries));
    useEffect(() => {
        let active = true;

        (async () => {
            const [galleries, err] = await props.world.fetchAllGalleries(props.host.name);
            if (err) {
                return;
            }

            if (!active) {
                return;
            }

            setGalleries(galleries);
        })();

        return () => {
            active = false;
        };
    }, []);
        

    return (
        <div className={styles["account"]}>
            <LogoContainer />

            {
                (function(){
                    let interestCount = 0;
                    let noPro = true;
                    localStorage.setItem('noPro', JSON.stringify(noPro));
                    localStorage.setItem('interestCount', JSON.stringify(interestCount));
                }())
            }

            <p><span>Email</span>: {props.host.email}</p>

            <p><span>Name</span>: {props.host.full_name}</p>

            <GalleryList galleries={galleries} />

            <div className={styles["new-gallery-btn-container"]}>
                <ActionLink to="/dashboard/new-gallery" className={styles["action-link"]}>
                    {props.is_trial ? "unlock trial gallery" : "purchase a new gallery" }
                </ActionLink>
            </div>

            <div className={styles["userguide-container"]}>
                <ActionLink href="https://tacboard.com/welcome-overview.html">
                    View User Guide
                </ActionLink>
            </div>

            <div className={styles["logout-container"]}>
                <ActionLink onClick={props.onLogout}>
                    Logout
                </ActionLink>
            </div>
        </div>
    );
};

export default Account;
